import React from 'react';
import './Terms.css';

const Terms = () => {
  return (
    <div className="container">
      <div className="content">
        <h1 className="mainTitle">Terms of Service – Fractional Ownership Platform</h1>
        <p className="effectiveDate">(Last updated: September 23, 2025)</p>

        <section className="section">
          <h2 className="sectionTitle">1. Introduction</h2>
          <p className="sectionText">These Terms of Service ("Agreement") govern your use of the website, mobile application, and services (together, the "Platform") operated by [Your Company Name Private Limited] ("we", "us", "our").</p>
          <p className="sectionText">By registering, accessing, or using the Platform, you agree to be bound by this Agreement. If you do not agree, you must not use the Platform.</p>
          <p className="sectionText">This Agreement is governed by and construed in accordance with the laws of India.</p>
        </section>

        <section className="section">
          <h2 className="sectionTitle">2. Modification of Terms</h2>
          <p className="sectionText">We may revise these Terms from time to time. Any changes will be updated on the Platform. Continued use of the Platform after such updates will be considered acceptance of the revised Terms.</p>
        </section>

        <section className="section">
          <h2 className="sectionTitle">3. Role of the Platform</h2>
          <p className="sectionText">The Platform is a technology enabler that facilitates fractional ownership of real estate.</p>
          <p className="sectionText">Properties are held by Special Purpose Vehicles (SPVs), incorporated as Private Limited Companies under Indian law.</p>
          <p className="sectionText">Investors become shareholders in the SPV, not in the Platform.</p>
          <p className="sectionText">The Platform does not own, sell, or manage properties listed, nor does it guarantee returns, profits, or appreciation.</p>
          <p className="sectionText">Our role is limited to:</p>
          <ul>
            <li>Listing curated opportunities.</li>
            <li>Onboarding investors with KYC compliance.</li>
            <li>Facilitating payments through escrow.</li>
            <li>Providing digital dashboards and resale facilities.</li>
          </ul>
        </section>

        <section className="section">
          <h2 className="sectionTitle">4. Description of Services</h2>
          <p className="sectionText">The Platform provides:</p>
          <ul>
            <li>Access to curated real estate opportunities via fractional ownership.</li>
            <li>Secure investment and payment processing through escrow.</li>
            <li>Share allotment in the relevant SPV upon completion of investment.</li>
            <li>Investor dashboards for ownership tracking.</li>
            <li>A resale marketplace for secondary transfers of fractions (SPV shares).</li>
          </ul>
        </section>

        <section className="section">
          <h2 className="sectionTitle">5. User Accounts</h2>
          <p className="sectionText">To use the Platform, you must register an account, be at least 18 years of age, and capable of entering into a legally binding contract.</p>
          <p className="sectionText">You must provide accurate and complete information during registration and update it as necessary.</p>
          <p className="sectionText">You are solely responsible for maintaining the confidentiality of your username, password, and any activity in your account.</p>
          <p className="sectionText">You agree to immediately notify us of any unauthorized access.</p>
        </section>

        <section className="section">
          <h2 className="sectionTitle">6. User Responsibilities</h2>
          <p className="sectionText">You agree not to:</p>
          <ul>
            <li>Misuse or attempt to hack the Platform.</li>
            <li>Upload or share unlawful, harmful, or misleading content.</li>
            <li>Infringe upon intellectual property rights of the Platform, SPVs, or other users.</li>
            <li>Circumvent, disable, or otherwise interfere with Platform features.</li>
            <li>Use the Platform for fraudulent, illegal, or unauthorized purposes.</li>
          </ul>
        </section>

        <section className="section">
          <h2 className="sectionTitle">7. Data Ownership & Privacy</h2>
          <p className="sectionText">You retain ownership of the personal information you provide.</p>
          <p className="sectionText">By using the Platform, you grant us a limited license to process, store, and use your information for providing services.</p>
          <p className="sectionText">Data is handled in accordance with our Privacy Policy ([insert link]).</p>
        </section>

        <section className="section">
          <h2 className="sectionTitle">8. Intellectual Property</h2>
          <p className="sectionText">All rights, titles, and interests in the Platform, its content, software, and trademarks are owned by us or our licensors.</p>
          <p className="sectionText">You may not copy, reproduce, or exploit any part of the Platform without prior written consent.</p>
        </section>

        <section className="section">
          <h2 className="sectionTitle">9. Risks & Disclaimers</h2>
          <p className="sectionText">Investments are subject to market, regulatory, execution, and liquidity risks.</p>
          <p className="sectionText">The Platform is not responsible for property performance, delays, or appreciation.</p>
          <p className="sectionText">Ownership rights arise solely through shareholding in the respective SPV.</p>
          <p className="sectionText">Past performance or projections are not indicative of future results.</p>
        </section>

        <section className="section">
          <h2 className="sectionTitle">10. Fees & Payments</h2>
          <ul>
            <li>Entry Fee: Nil.</li>
            <li>Resale Fee: 1% from buyer + 1% from seller.</li>
            <li>Exit Fee: 2% of final sale proceeds before profit distribution.</li>
          </ul>
          <p className="sectionText">All payments must be made through authorized escrow channels only.</p>
        </section>

        <section className="section">
          <h2 className="sectionTitle">11. Refund Policy</h2>
          <p className="sectionText">Payments made into escrow are refundable only under specified conditions (e.g., land purchase failure, title defect).</p>
          <p className="sectionText">Once shares are allotted in an SPV, investments are non-refundable except through resale or exit.</p>
        </section>

        <section className="section">
          <h2 className="sectionTitle">12. Permissions</h2>
          <p className="sectionText">By using the Platform, you consent to device-level permissions (camera, storage, contacts, location) for:</p>
          <ul>
            <li>Document uploads and KYC verification.</li>
            <li>Storing and downloading reports and certificates.</li>
            <li>Using referral features and location-based services.</li>
          </ul>
        </section>

        <section className="section">
          <h2 className="sectionTitle">13. Communication & Alerts</h2>
          <p className="sectionText">You consent to receive transactional, legal, and promotional communications from us via email, SMS, or app notifications.</p>
        </section>

        <section className="section">
          <h2 className="sectionTitle">14. Breach of Terms</h2>
          <p className="sectionText">If you breach these Terms, we may take appropriate action including suspension or termination of your account, blocking access, and legal proceedings if necessary.</p>
        </section>

        <section className="section">
          <h2 className="sectionTitle">15. Indemnification</h2>
          <p className="sectionText">You agree to indemnify and hold harmless the Platform, its directors, employees, and partners from any claims, damages, or losses arising from your use of the Platform, breach of Terms, or violation of rights of third parties.</p>
        </section>

        <section className="section">
          <h2 className="sectionTitle">16. Limitation of Liability</h2>
          <p className="sectionText">The Platform is not liable for property disputes, title claims, or project execution delays.</p>
          <p className="sectionText">Our liability is limited to services provided directly by us (listing, payment facilitation, dashboard access).</p>
          <p className="sectionText">Maximum liability in any case will not exceed the fees paid by you to the Platform.</p>
        </section>

        <section className="section">
          <h2 className="sectionTitle">17. Governing Law & Dispute Resolution</h2>
          <p className="sectionText">These Terms are governed by the laws of India.</p>
          <p className="sectionText">Any disputes shall be resolved via arbitration in [Insert City], under the Arbitration & Conciliation Act, 1996.</p>
        </section>

        <section className="section">
          <h2 className="sectionTitle">18. Contact Information</h2>
          <p className="sectionText">For queries, please contact:</p>
          <p className="sectionText">[Your Company Name Private Limited]</p>
          <p className="sectionText">[Registered Office Address]</p>
          <p className="sectionText">Email: [support@yourplatform.in]</p>
        </section>
      </div>
    </div>
  );
};

export default Terms;
